import { CheckboxInverse } from '../components/FacetHandlers';
import TypeaheadFallback from '../components/FacetHandlers/Typeahead/Fallback';

import type { FacetConfig, FacetValue } from '../types';

import { mungeTaxonomy } from '../utils/munge';

import {
  getCompanyData,
  getProductData,
  getTaxonomyData,
  getTERNumberData
} from '../utils';
import { getLazyFacetHandler } from '../components/FacetHandlers/Lazy/Lazy';

const data: Record<string, any[]> = {
  csi: [],
  clients: [],
  products: [],
  ters: []
};

export async function getConfig(): Promise<FacetConfig[]> {
  return [
    {
      name: 'ter',
      label: 'Report Number',
      index: 'ss_field_report_number',
      facetFallback: TypeaheadFallback,
      facetHandler: getLazyFacetHandler(
        data,
        'ters',
        () =>
          getTERNumberData().then(data =>
            data
              .map(item => ({ id: item.name, name: item.name }))
              .filter(item => item.id && item.name)
          ),
        () => import('../components/FacetHandlers/Typeahead/Typeahead')
      ),
      value: data.ters
    },
    {
      name: 'product',
      label: 'Product',
      index: 'itm_field_product_reference',
      facetFallback: TypeaheadFallback,
      facetHandler: getLazyFacetHandler(
        data,
        'products',
        () =>
          getProductData().then(data =>
            data
              .map(item => ({ id: item.nid, name: item.name }))
              .filter(item => item.id && item.name)
          ),
        () => import('../components/FacetHandlers/Typeahead/Typeahead')
      ),
      value: data.products
    },
    {
      name: 'client',
      label: 'Client',
      index: 'itm_field_client_reference',
      facetFallback: TypeaheadFallback,
      facetHandler: getLazyFacetHandler(
        data,
        'clients',
        () =>
          getCompanyData().then(data =>
            data
              .map(item => ({ id: item.nid, name: item.name }))
              .filter(item => item.id && item.name)
          ),
        () => import('../components/FacetHandlers/Typeahead/Typeahead')
      ),
      value: data.clients
    },
    {
      name: 'csi',
      label: 'CSI Section',
      index: 'itm_field_csi_section',
      facetHandler: getLazyFacetHandler(
        data,
        'csi',
        () => getTaxonomyData().then(mungeTaxonomy),
        () => import('../components/FacetHandlers/Typeahead/Typeahead')
      ),
      facetFallback: TypeaheadFallback,
      value: data.csi,
      options: {
        persistCounts: true
      }
    },
    {
      name: 'legacy',
      label: 'Hide Legacy Documents',
      index: 'bs_field_legacy_document',
      facetHandler: CheckboxInverse,
      onChange: (value: FacetValue) => (value ? null : value)
    }
  ];
}
